module.exports = __webpack_public_path__ + "static/media/GalleryImage14.666fb439.jpg";